// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d7aea5ef","70":"e7a5bf8e","71":"123f7678","195":"281c46b2","293":"d146e48c","349":"d2894619","360":"7aaa673f","377":"31d356e5","419":"56fb50f6","606":"35ecb6b7","621":"5e10a4c2","866":"9cec118b","870":"543b6155"}[chunkId] + ".chunk.js";
};